import React, { FC } from 'react'

import { getMobileNavEvent, IconLink, TrustIconProps } from '@Components/TrustIcons/common'

export const TrustIconDE: FC<TrustIconProps> = ({ variant }: TrustIconProps) => (
  <IconLink
    analytics={getMobileNavEvent('trustedshops', variant)}
    href="https://www.trustedshops.de/bewertung/info_X65F1BC0E9146075A175FFD0E17748A60.html"
    rel="noopener noreferrer"
    target="_blank"
    variant={variant}
  >
    <img alt="" src="https://eu-images.contentstack.com/v3/assets/blt7dcd2cfbc90d45de/blt3b30b87a9b34b1e6/trusted-shops-logo.png" />
  </IconLink>
)
